import * as Yup from 'yup';

const INITIAL_VALUES_ADD_ADMIN = {
    email: '',
    access: []
};

const VALIDATION_SCHEMA_ADD_ADMIN = Yup.object().shape({
    email: Yup.string().required("Enter an email id").email("Invalid Email"),
    access: Yup.array()
        .min(1, 'Pick at least 1 role')
        .of(
            Yup.object().shape({
                label: Yup.string().required(),
                value: Yup.string().required(),
            })
        )
});

const INITIAL_VALUES_ADD_LIMIT = {
    amount: 0
};

const VALIDATION_SCHEMA_ADD_LIMIT = Yup.object().shape({
    amount: Yup.number().required("Enter an Amount")
});

const INITIAL_VALUES_PURCHASE_LIMIT = {
    purchaseLimit: 0
};

const VALIDATION_SCHEMA_PURCHASE_LIMIT = Yup.object().shape({
    purchaseLimit: Yup.number().required("Enter an Amount")
});



export { INITIAL_VALUES_ADD_ADMIN,
    VALIDATION_SCHEMA_ADD_ADMIN,
    INITIAL_VALUES_ADD_LIMIT,
    VALIDATION_SCHEMA_ADD_LIMIT,
    INITIAL_VALUES_PURCHASE_LIMIT,
    VALIDATION_SCHEMA_PURCHASE_LIMIT,
};
